import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Frame } from './screens/Frame'
import { LandingScreen } from './screens/LandingScreen'

export const router = createBrowserRouter([
  {
    // Persistent phone shell around every campaign surface (Landing/Working/error/loading).
    element: <Frame />,
    children: [
      // `/c/<code>` is every campaign's permanent link (printed QR codes, ADR 0161 §4); `/o/<code>` is the
      // form shared from now on — a path no native shell claims, so a campaign always opens in a browser.
      // Both render the same screen; the campaign's type decides what it does.
      { path: '/c/:code', element: <LandingScreen /> },
      { path: '/o/:code', element: <LandingScreen /> },
      // Post-auth return from accounts-web: proceed automatically.
      { path: '/c/:code/resume', element: <LandingScreen autoResume /> },
      { path: '/o/:code/resume', element: <LandingScreen autoResume /> },
      { path: '*', element: <Navigate to="/c/_" replace /> },
    ],
  },
])
